var s1 = require('../../assets/images/buildings/pic1.jpg');
var s2 = require('../../assets/images/buildings/pic2.jpg');
var s3 = require('../../assets/images/buildings/pic3.jpg');
var s4 = require('../../assets/images/buildings/pic4.jpg');
var s5 = require('../../assets/images/buildings/pic5.jpg');
var s6 = require('../../assets/images/buildings/pic6.jpg');

const DataOwlCarouselFacilityCampus = [
  {
    id: 1,    
	title:'School Facilites',
	icon:'flaticon-people',
	tab :[
	  {
	  	id: 1,    
		title:'Smart Class Rooms',
		link:'/classrooms',
		image:s1,
		description:"A Smart Classroom is an educational setting with advanced technologies supporting dynamic teaching and learning. These classrooms typically include tools such as projectors, smartboards, digital content libraries, computers, internet connectivity, and learning management systems (LMS)."
	  },
	  {
	  	id: 2,    
		title:'Sports',
		link:'/sports',
		image:s2,
		description:"Students learn to cooperate, communicate, and rely on teammates, which helps them work well with others in various life situations."
	  },{
	  	id: 3,    
		title:'School Library',
		link:'/library',
		image:s3,
		description:"School libraries play a pivotal role in shaping students’ academic and personal development."
	  },{
	  	id: 4,    
		title:'School Labs',
		link:'/labs',
		image:s4,
		description:"Laboratories in schools play a crucial role in enhancing the educational experience by providing hands-on learning opportunities."
	  },{
	  	id: 5,    
		title:'Transport Facility',
		link:'/transport',
		image:s5,
		description:"A school bus is any type of bus owned, leased, contracted to, or operated by a school or school district. It is regularly used to transport students to and from school or school-related activities, but not including a charter bus or transit bus."
	  },{
	  	id: 6,    
		title:'Music and Dance',
		link:'/music&dance',
		image:s6,
		description:"Dance and music are more than just artistic activities; they are powerful tools that greatly contribute to students’ personal growth. Participating in these creative pursuit’s nurtures self-expression, builds confidence, and supports emotional well-being. This blog highlights the importance of dance and music for students, emphasizing how these art forms can enrich both their academic and personal lives by enhancing student expression and confidence with dance and music."
	  }
	  ]
	  
  },
  {
    id: 2,
	title:'Class Rooms',
	icon:'flaticon-team',
	tab :[
		  {
			id: 1,    
			title:'Prayer Room',
			link:'/classrooms',
			image:s2,
			description:"Prayer spaces give children and young people a way to explore personal reflection and prayer for themselves using a selection of engaging and creative activities."
		  },
		  {
			id: 2,    
			title:'Office Room',
			link:'/classrooms',
			image:s1,
			description:"The office of the school’s principal, often used for administrative tasks, meetings, or disciplinary actions."
		  },{
			id: 3,    
			title:'Class Rooms',
			link:'/classrooms',
			image:s3,
			description:"The classroom layout with tables which form groups is common in early years and elementary / primary school classrooms. This is also my ideal classroom layout for my approach to teaching. "
		  },{
			id: 4,    
			title:'Rest Room',
			link:'/classrooms',
			image:s3,
			description:"Restrooms offers specially designed restrooms for schools and educational institutions."
		  },{
			id: 5,    
			title:'Sports Room',
			link:'/classrooms',
			image:s3,
			description:"The widest range of sports activities in our school includes a combination of Indoor and Outdoor games, sports and equipment."
		  },{
			id: 6,    
			title:'The computer room',
			link:'/classrooms',
			image:s3,
			description:"The computer room, also known as the computer lab, serves as the centre for teaching the computer to classes, usually by a professional computer teacher."
		  }
		  ]
 },
  {
    id: 3,
	title:'Sports',
	icon:'flaticon-team',
	tab :[
		  {
			id: 1,    
			title:'Bollyboll Ground',
			link:'/sports',
			image:s1,
			description:"Volleyball court dimensions vary depending on league standards, the age of participants, and whether the match is held indoors or outdoors."
		  },
		  {
			id: 2,    
			title:'Basket Ball Ground',
			link:'/sports',
			image:s2,
			description:"Basketball court dimensions and size vary based on the level of play."
		  },{
			id: 3,    
			title:'Kids Play Ground ',
			link:'/sports',
			image:s3,
			description:"A playground is not just a bunch of equipment; it is an entirely new and exciting world for children to explore as they grow and learn with every obstacle they face and peer they play with."
		  },{
			id: 4,    
			title:'Music & Dance Places',
			link:'/sports',
			image:s4,
			description:"The inclusion of music, dance, and art education in schools is crucial for the holistic development of children."
		  },{
			id: 5,    
			title:'Other Play Facilites',
			link:'/sports',
			image:s5,
			description:"Playgrounds provide children with an environment where they can engage in unstructured play."
		  },{
			id: 6,    
			title:'Cirket Ground',
			link:'/sports',
			image:s6,
			description:"Children receive formal training in a variety of sports from well-trained and qualified trainers and coaches."
		  }
		  ]
  },
  {
    id: 4,
	title:'Library',
	icon:'flaticon-mirror',
	tab :[
		  {
			id: 1,    
			title:'School Books',
			link:'/library',
			image:s1,
			description:"The school library is an integral part of the school system that contributes towards literacy, research, and reading for pleasure. This free course is aimed at both librarians who are new to the field as well as those with experience who are looking to up-skill, and explores how you can enhance the library provision in your school."
		  },
		  {
			id: 2,    
			title:'Social Study Books',
			link:'/library',
			image:s2,
			description:"The Best Social Studies Library List These are the books that social studies enthusiasts, students in particular, should read."
		  },{
			id: 3,    
			title:'Story Books',
			link:'/library',
			image:s3,
			description:"Moral Story Books for Kids."
		  },{
			id: 4,    
			title:'News and Cirket',
			link:'/library',
			image:s4,
			description:"News and Cirket books for Kids."
		  },{
			id: 5,    
			title:'Poetry',
			link:'/library',
			image:s5,
			description:"Poetry books for Kids."
		  },{
			id: 6,    
			title:'Modern Literature',
			link:'/library',
			image:s6,
			description:"Some books are lightning bolts charged, immediate, and born of the era that shaped them. But only a few strike deep enough to echo through generations. While school curricula are often slow to evolve, certain contemporary works are impossible to ignore. They speak to identity, technology, memory, violence, grief, and human resilience. "
		  }
		  ]
  },
  {
    id: 5,
	title:'Music & Dance',
	icon:'flaticon-envelope',
	tab :[
		  {
			id: 1,    
			title:'Independence Day',
			link:'/music&dance',
			image:s1,
			description:"Independence Day is celebrated in schools to instill patriotism in students and spread awareness about India's struggle for independence."
		  },
		  {
			id: 2,    
			title:'Annual Functions',
			link:'/music&dance',
			image:s2,
			description:"The annual function of the school is one the most awaited events for the students during their school life. Every child, teachers, and even parents of the students wait for the annual function of the school. Everyone gets to enjoy, celebrate, and have fun together. Annual Day is an important element of every school’s calendar. It is a time of celebration, felicitation, feasting, and festivity when students not only present their outstanding performances but also earn awards for their academic and co-curricular achievements. "
		  },{
			id: 3,    
			title:'Child Club',
			link:'/music&dance',
			image:s3,
			description:"These after school club ideas are sure to help children develop socially as well as help them learn to work as a team and move ideas forward which will serve them well throughout their life."
		  },{
			id: 4,    
			title:'Dance Classes',
			link:'/music&dance',
			image:s4,
			description:"Our classes cover a wide range of dance styles, including classical Indian dance forms like Bharatanatyam and Kathak, as well as popular styles like Bollywood and hip hop."
		  },{
			id: 5,    
			title:'Cultural Fest',
			link:'/music&dance',
			image:s5,
			description:"There is ongoing debate about the role of cultural activities in students’ lives. Some believe students should focus solely on academics, but this view is changing."
		  },{
			id: 6,    
			title:'Talent Show',
			link:'/music&dance',
			image:s6,
			description:"Hosting a talent show is a great way to bring students, teachers, and parents together for a night of entertainment! The children will relish the opportunity to compete and cheer one another on, and the buzz generated by your talent show can open the door to being able to host similar events in the future."
		  }
		  ]
  },
  {
    id: 6,
	title:'Experiential Learning',
	icon:'flaticon-people',
	tab :[
		  {
			id: 1,    
			title:'Experiential Learning',
			link:'/art&craft',
			image:s1,
			description:"School trips provide students with hands-on learning experiences that go beyond the confines of the classroom. They allow students to see, touch, and interact with the subjects they’re studying, fostering a deeper understanding and retention of knowledge."
		  },
		  {
			id: 2,    
			title:'Cultural Immersion',
			link:'/art&craft',
			image:s2,
			description:"Visiting historical sites, museums, and cultural landmarks exposes students to different cultures, traditions, and ways of life. It broadens their perspectives and encourages respect and appreciation for diversity."
		  },{
			id: 3,    
			title:'Social Development',
			link:'/art&craft',
			image:s3,
			description:"School tours encourage teamwork, cooperation, and social interaction among students. They provide opportunities for students to bond with their peers, develop friendships, and strengthen interpersonal skills."
		  },{
			id: 4,    
			title:'Personal Growth',
			link:'/art&craft',
			image:s4,
			description:"Stepping out of their comfort zones during excursions encourages students to become more independent, adaptable, and resilient. They learn to navigate unfamiliar environments, solve problems, and overcome challenges, fostering personal growth and confidence."
		  },{
			id: 5,    
			title:'Discipline',
			link:'/art&craft',
			image:s5,
			description:"Teachers often expect the students to be on their best behaviour when on a field trip. Students follow these instructions well, as they are aware that their behaviour will reflect on their school."
		  },{
			id: 6,    
			title:'Opportunity',
			link:'/art&craft',
			image:s6,
			description:"Educational excursions organised by schools allow students to travel to these new sites. It also provides the less fortunate students an opportunity to travel to these places without incurring much expenses."
		  }
		  ]
  },
];

export default DataOwlCarouselFacilityCampus;